module.exports = __webpack_public_path__ + "img/03_L1.cca8d1d4.svg";